// ContabilidadRoutesXL - Sprint 44 Fase 3 Vista 8.
// Reemplaza modules/contabilidad/routes.jsx. Rutas preservadas exactas.
import { Routes, Route, Navigate } from 'react-router-dom';
import CuentasListXL from './cuentas/CuentasListXL';
import CuentaFormXL from './cuentas/CuentaFormXL';
import AsientosListXL from './asientos/AsientosListXL';
import AsientoFormXL from './asientos/AsientoFormXL';
import ReportesHomeXL from './reportes/ReportesHomeXL';
import BalanceGeneralXL from './reportes/BalanceGeneralXL';
import EstadoResultadosXL from './reportes/EstadoResultadosXL';
import LibroMayorXL from './reportes/LibroMayorXL';
import AuxiliarCuentaXL from './reportes/AuxiliarCuentaXL';

export default function ContabilidadRoutesXL() {
  return (
    <Routes>
      <Route index element={<Navigate to="cuentas" replace />} />
      <Route path="cuentas" element={<CuentasListXL />} />
      <Route path="cuentas/nueva" element={<CuentaFormXL />} />
      <Route path="cuentas/:id" element={<CuentaFormXL />} />
      <Route path="asientos" element={<AsientosListXL />} />
      <Route path="asientos/nuevo" element={<AsientoFormXL />} />
      <Route path="asientos/:id" element={<AsientoFormXL />} />
      <Route path="reportes" element={<ReportesHomeXL />} />
      <Route path="reportes/balance" element={<BalanceGeneralXL />} />
      <Route path="reportes/estado-resultados" element={<EstadoResultadosXL />} />
      <Route path="reportes/libro-mayor" element={<LibroMayorXL />} />
      <Route path="reportes/auxiliar-tercero" element={<AuxiliarCuentaXL />} />
    </Routes>
  );
}
